import { Modal } from "react-bootstrap";
import ProductCategoryItemDialogHeader from "./ProductCategoryItemDialogHeader";
import ProductCategoryItemAddForm from "./ProductCategoryItemAddForm";

const ProductCategoryItemAddDialog = ({
  onHide,
  onSuccess,
  plant,
  productGroup,
  productType,
  singleProduct,
  productCategoryData,
}: any) => {
  return (
    <Modal size="lg" show={true} aria-labelledby="example-modal-sizes-title-lg">
      <ProductCategoryItemDialogHeader
        productGroup={productGroup}
        singleProduct={singleProduct}
      />
      <ProductCategoryItemAddForm
        productGroup={productGroup}
        productType={productType}
        onHide={onHide}
        onSuccess={onSuccess}
        plant={plant}
        singleProduct={singleProduct}
        productCategoryData={productCategoryData}
      />
    </Modal>
  );
};

export default ProductCategoryItemAddDialog;
